export default __webpack_public_path__ + "static/media/Cup.de3a5852.svg";